module.exports = __webpack_public_path__ + "img/1-08.bff07585.jpg";